import { BatchDataStatus } from 'configs/constants';
import type { IBatchData } from 'types/store';
import BatchDataService from 'pages/Batch/sections/Context/BatchDataService';

// Pushes pipeline items into BatchDataService, which uploads any blob: URLs to CDN
// as a side effect (see BatchDataService.prepareAppliedData). Call this before any
// step that needs a CDN URL (remote toolchain steps, webhook submissions, etc.).
export async function persistItemsToService(items: IBatchData[]): Promise<void> {
  const allStoredData = BatchDataService.getAllData();
  const itemsByKey = new Map(items.map(item => [item.key, item]));
  const mergedData = allStoredData.map(stored => itemsByKey.get(stored.key) || stored);
  const selectedKeys = items.filter(item => item.status !== BatchDataStatus.ERROR).map(item => item.key);
  await BatchDataService.putMultipleData(mergedData, selectedKeys);
}

// Same as persistItemsToService, plus returns the items refreshed from the service
// so callers can read the CDN URLs the upload just produced.
export async function persistAndReadItems(items: IBatchData[]): Promise<IBatchData[]> {
  await persistItemsToService(items);
  const refreshed = new Map(BatchDataService.getAllData().map(item => [item.key, item]));
  return items.map(item => refreshed.get(item.key) ?? item);
}
